import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }) => {
    const response = await axios.get(
      "https://mdos.calendarehr.com/api_main.php/login",
      {
        params: { email, password },
      }
    );
    console.log(response.data);
    if (response.data.status === "success") {
      console.log(response);
      return response.data.user;
    } else {
      throw new Error(response.data.message);
    }
  }
);

export const performLogout = createAsyncThunk("auth/logout", async () => {
  const response = await axios.get(
    "https://mdos.calendarehr.com/api_main.php/logout"
  );
  if (response.data.status === "success") {
    return;
  } else {
    throw new Error(response.data.message);
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: false,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = "loading";
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(performLogout.pending, (state) => {
        state.status = "loading";
      })
      .addCase(performLogout.fulfilled, (state) => {
        state.status = "succeeded";
        state.user = null;
        state.isAuthenticated = false;
      })
      .addCase(performLogout.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default authSlice.reducer;
